import { getOrderDetails } from '@/api/getOrderDetails';
import { getTableDetails } from '@/api/getTableDetails';
import useValidateQueryParams from './useValidateQueryParams';

export const useCheckBill = () => {
  const { queryParams } = useValidateQueryParams();
  const { outletId, tableNumber, counterNumber } = queryParams();

  if (!tableNumber && !counterNumber) {
    throw new Error('Counter number or table number are required');
  }

  if (!outletId) {
    throw new Error('Outlet ID is required');
  }

  const getBillDetails = () => {
    if (counterNumber) {
      return getOrderDetails({ outletId, counterNumber });
    }
    if (tableNumber) {
      return getTableDetails({ outletId, tableNumber });
    }
    throw new Error('Counter number or table number are required');
  };

  return async (originalAmount: number) => {
    const bill = await getBillDetails();
    const { total: billTotal } = bill;
    return {
      billHasNotChanged: billTotal === originalAmount,
    };
  };
};
